/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import HeaderComponent from "../../Pages/Header/Header";
import "./Tabs.css";
import property_name from "../../images/Community-Image.webp";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  fetchCommunityByCommunityId,
  vendorCheckOrCreate,
  updateCommunityApi,
  fetchRealtorDetails,
} from "../../Services/Community/CommunityAPI/communityApi";
import { toUpperCase } from "../../Utils/LetterCase";
import Loader from "../../Utils/Loader";
import { CommunityOwner } from "../../Utils/Constant";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptId } from "../../Utils/Crypto";
import ImageCropper from "./ImageCropper/ImageCropper";
import { realtorWebcardApi } from "../../Services/Realtor/RealtorApi/RealtorApi";
import WebcardHeader from "./WebcardHeader/WebcardHeader";
import Education from "./Vendors/Education";
import Health from "./Vendors/Health";
import RealEstate from "./Vendors/RealEstate";
import LocalVendor from "./Vendors/LocalVendor";
import Document from "./Document/Document";
import Rules from "./Rules/Rules";
import Overview from "./Overview/Overview";
import Banner from "./Banner/Banner";
import OverviewButton from "./TabButtons/Overview";
import RulesButton from "./TabButtons/Rules";
import DocumentButton from "./TabButtons/Document";
import ApplicationButton from "./TabButtons/Application";
import EducationButton from "./TabButtons/Education";
import RealEstateButton from "./TabButtons/RealEstate";
import HealthButton from "./TabButtons/Health";
import LocalVendorButton from "./TabButtons/LocalVendor";
import MapButton from "./TabButtons/Map";
import EventsButton from "./TabButtons/Events";
import { ThreeDot } from "react-loading-indicators";
import { Box } from "@mui/material";

function TabsComponent() {
  const [activeTab, setActiveTab] = useState("overview");
  let { data } = useSelector((state) => state.communityById);
  const { loading: communityLoading } = useSelector(
    (state) => state.communityById
  );
  const location = useLocation();
  const { encryptedId, realtorCode } = useParams();
  const id = decryptId(encryptedId);
  const dispatch = useDispatch();
  const [comData, setComData] = useState({});
  const [comOver, setComOver] = useState();
  const [comVendor, setComVendor] = useState([]);
  const [comHealthVendor, setComHealthVendor] = useState([]);
  const [comRealtorVendor, setComRealtorVendor] = useState([]);
  const [comEducationVendor, setComEducationVendor] = useState([]);
  const userType = localStorage.getItem("user_type");
  const [isLocalVendorLoading, setIsLocalVendorLoading] = useState(false);
  const [isEducationVendorLoading, setIsEducationVendorLoading] =
    useState(false);
  const [isHealthVendorLoading, setIsHealthVendorLoading] = useState(false);
  const [isRealtorVendorLoading, setIsRealtorVendorLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [banners, setBanners] = useState([]);
  const { data: profile } = useSelector((state) => state.realtorWebcard);
  const { publicData, privateData } = useSelector(
    (state) => state.getAllDocument
  );

  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  const approvalStatus = queryParams.get("approvalStatus");

  const vendorGroupData = useMemo(() => {
    if (!Array.isArray(comVendor)) return {};

    return comVendor.reduce((acc, vendor) => {
      if (!acc[vendor.sub_vendor_name]) {
        acc[vendor.sub_vendor_name] = [];
      }
      acc[vendor.sub_vendor_name].push(vendor);
      return acc;
    }, {});
  }, [comVendor]);

  useEffect(() => {
    dispatch(realtorWebcardApi(realtorCode)); // Fetch profile data
  }, [dispatch, realtorCode]);

  useEffect(() => {
    if (id) {
      dispatch(fetchCommunityByCommunityId(id));
      if (data.status === 409) dispatch(fetchCommunityByCommunityId(id));
    }
  }, [id, dispatch, data.status]);

  useEffect(() => {
    dispatch(fetchRealtorDetails({ community_id: id }));
  }, [dispatch, id]);

  useEffect(() => {
    if (data) {
      setComData(data?.data);
      setComOver(data?.data?.community_overview);
      setImageUrl(data?.data?.community_image);
      setBanners(data?.data?.advertisement_banners);
    }
  }, [data, dispatch]);

  const handleVendorCheckOrCreate = useCallback(
    (category, loading, vendorData) => {
      if (!data?.data?.location?.city || loading || vendorData?.length) return; // Prevent re-fetching if data exists
      const categoryMapping = {
        education: {
          setLoading: setIsEducationVendorLoading,
          setVendor: setComEducationVendor,
        },
        community_expert: {
          setLoading: setIsRealtorVendorLoading,
          setVendor: setComRealtorVendor,
        },
        health: {
          setLoading: setIsHealthVendorLoading,
          setVendor: setComHealthVendor,
        },
        local_vendor: {
          setLoading: setIsLocalVendorLoading,
          setVendor: setComVendor,
        },
      };
      const selectedCategory = categoryMapping[category];
      if (!selectedCategory) return;
      selectedCategory.setLoading(true);
      dispatch(
        vendorCheckOrCreate({
          city: data?.data?.location?.city,
          category,
          location_id: data?.data?.location?.id,
        })
      )
        .then((response) =>
          selectedCategory.setVendor(response?.payload?.data || [])
        )
        .finally(() => selectedCategory.setLoading(false));
    },
    [data, dispatch]
  );

  const memoizedVendorData = useMemo(
    () => ({
      education: comEducationVendor,
      community_expert: comRealtorVendor,
      health: comHealthVendor,
      local_vendor: comVendor,
    }),
    [comEducationVendor, comRealtorVendor, comHealthVendor, comVendor]
  );

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
      };
    }
  };

  const tabComponents = {
    overview: (
      <Overview
        communityName={comData?.community_name}
        comData={comData}
        comOver={comOver}
      />
    ),
    rules: <Rules communityName={comData?.community_name} comData={comData} />,
    documents: (
      <Document
        publicData={publicData}
        privateData={privateData}
        communityName={comData?.community_name}
        comData={comData}
      />
    ),
    "real-estate": isRealtorVendorLoading ? (
      <Loader />
    ) : (
      <RealEstate
        comRealtorVendor={comRealtorVendor}
        communityName={comData?.community_name}
      />
    ),
    health: isHealthVendorLoading ? (
      <Loader />
    ) : (
      <Health
        comHealthVendor={comHealthVendor}
        communityName={comData?.community_name}
      />
    ),
    vendors: isLocalVendorLoading ? (
      <Loader />
    ) : (
      <LocalVendor
        vendorGroupData={vendorGroupData}
        communityName={comData?.community_name}
      />
    ),
    education: isEducationVendorLoading ? (
      <Loader />
    ) : (
      <Education
        comEducationVendor={comEducationVendor}
        communityName={comData?.community_name}
      />
    ),
  };

  const handleImageUpdate = async (file) => {
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("community_image", file);
    try {
      const response = await dispatch(
        updateCommunityApi({ communityId: id, formData: formDataToSubmit })
      ).unwrap();
      if (response.status === 200) {
        toast.success("Image uploaded successfully!");
        // Fetch updated community data
        const updatedRes = await dispatch(
          fetchCommunityByCommunityId(id)
        ).unwrap();
        setComData(updatedRes?.data);
        setImageUrl(updatedRes?.data?.community_image);
      }
    } catch (error) {
      toast.error("Image upload failed! Please try again.");
      console.error("Upload error:", error);
    }
  };

  if (communityLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <ThreeDot color="#e55426" size="small" text="" textColor="" />
      </Box>
    );
  }

  return (
    <>
      <>
        {location.pathname.includes("/admin/tab") ||
        location.pathname.includes("/super-admin/tab") ||
        location.pathname.includes("/home-owner-admin/tab") ||
        location.pathname.includes("/realtor/tab") ||
        realtorCode ? null : (
          <HeaderComponent />
        )}
        <section className="tab-group">
          <div className="">
            {realtorCode && <WebcardHeader realtorCode={realtorCode} />}
            {realtorCode && (
              <div className="inner-wrapper-box mobile-view-box">
                <div className="upper-block header-blk d-flex justify-content-between align-items-center">
                  <div className="company-name-block">
                    <img src={profile?.brokerage_logo} alt="company-logo" />
                  </div>
                  <div className="user-name-block">
                    <img src={profile?.image} alt="profile-pic" />
                  </div>
                </div>
              </div>
            )}

            <div className="inner-wrapper-box">
              <div className="upper-block d-flex justify-content-between">
                <div className="upper-left-block order-2 order-lg-1">
                  <h2>{toUpperCase(comData?.community_name)}</h2>
                  <div className="line"></div>
                  {/* city ------------------------------------------------------------------------->*/}
                  <div className="title-info">
                    {comData?.location?.city
                      ? `${comData?.location?.city}, `
                      : ""}{" "}
                    {comData?.location?.state}
                  </div>
                  <div className="title-unit">
                    {comData?.type ? `${comData?.type} | ` : null}
                    {comData?.unit ? `${comData?.unit} Units` : null}
                  </div>
                  <div>
                    <div className="tab-buttons">
                      <OverviewButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("overview")}
                      />
                      <RulesButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("rules")}
                      />
                      <DocumentButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("documents")}
                      />
                      {comData?.application_url || comData?.application_doc ? (
                        <ApplicationButton
                          activeTab={activeTab}
                          comData={comData}
                        />
                      ) : null}
                      <EducationButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("education")}
                        handleVendorCheckOrCreate={() =>
                          handleVendorCheckOrCreate(
                            "education",
                            isEducationVendorLoading,
                            memoizedVendorData.education
                          )
                        }
                      />
                      {!realtorCode ? (
                        <RealEstateButton
                          activeTab={activeTab}
                          setActiveTab={() => setActiveTab("real-estate")}
                          handleVendorCheckOrCreate={() =>
                            handleVendorCheckOrCreate(
                              "community_expert",
                              isRealtorVendorLoading,
                              memoizedVendorData.community_expert
                            )
                          }
                          realtorCode={realtorCode}
                        />
                      ) : null}
                      <HealthButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("health")}
                        handleVendorCheckOrCreate={() =>
                          handleVendorCheckOrCreate(
                            "health",
                            isHealthVendorLoading,
                            memoizedVendorData.health
                          )
                        }
                      />
                      <LocalVendorButton
                        activeTab={activeTab}
                        setActiveTab={() => setActiveTab("vendors")}
                        handleVendorCheckOrCreate={() =>
                          handleVendorCheckOrCreate(
                            "local_vendor",
                            isLocalVendorLoading,
                            memoizedVendorData.local_vendor
                          )
                        }
                      />
                      {comData?.map_url ? (
                        <MapButton activeTab={activeTab} comData={comData} />
                      ) : null}
                      {comData?.event_url || comData?.event_doc ? (
                        <EventsButton activeTab={activeTab} comData={comData} />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column flex-lg-column-reverse gap-2 justify-content-end order-1 order-lg-2 upper-right-block">
                  <div className="tab-img">
                    <img
                      src={imageUrl || property_name}
                      alt={comData?.community_name}
                    />
                    {userType === CommunityOwner &&
                    status === "accept" &&
                    approvalStatus === "approved" ? (
                      <label className="edit-label">
                        <input
                          type="file"
                          accept="image/*"
                          className="edit-input"
                          onChange={(e) => handleFileUpload(e)}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                          />
                        </svg>
                        Edit
                      </label>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="tabs-banner-img">
                <Banner banners={banners} />
              </div>
              <div className="lower-block">
                {tabComponents[activeTab] || null}
              </div>
            </div>
          </div>
        </section>
      </>
      {showCropper && (
        <ImageCropper
          image={imageSrc}
          onCropComplete={(croppedFile) => {
            setShowCropper(false);
            handleImageUpdate(croppedFile);
          }}
          onClose={() => setShowCropper(false)}
          id={id}
        />
      )}
    </>
  );
}

export default TabsComponent;
